/**
 * t('English string') with the English string as the key, matching loop-web's
 * convention exactly so the catalogue ports without a rename pass.
 *
 * No user facing string is ever written inline in JSX. That is not a style
 * preference: it is the only way the pseudo locale can prove the layout
 * survives 1.4x expansion, and the only way Charlie inherits a complete
 * catalogue instead of a DOM sweep.
 */

import type { Lang } from '../types';
import { en } from './en';
import { pseudo } from './pseudo';
import { th } from './th';

let currentLang: Lang = 'en';

export function setLang(lang: Lang): void {
  currentLang = lang;
}

export function getLang(): Lang {
  return currentLang;
}

export type Vars = Record<string, string | number>;

function interpolate(source: string, vars?: Vars): string {
  if (!vars) return source;
  return Object.entries(vars).reduce(
    (out, [key, value]) => out.split(`{${key}}`).join(String(value)),
    source,
  );
}

export function t(key: string, vars?: Vars): string {
  if (currentLang === 'th') return interpolate(th[key] ?? key, vars);
  if (currentLang === 'pseudo') return interpolate(pseudo(en[key] ?? key), vars);
  return interpolate(en[key] ?? key, vars);
}
